import React, { useMemo, useRef, useState } from 'react';
import { TextArea, TextBox } from '../../shared/controls/form';
import { AgGridReact } from 'ag-grid-react';
import { useSelector } from 'react-redux';
import { getProductDropdown, getProductList } from '../../redux/selector';
import Select from 'react-select';
import SelectBox from '../../shared/controls/form/selectBox';
import apiServices from '../../services/service';
import { toast } from 'react-toastify';
import { productInputData } from '../../shared/constants';
import { fetchDataAndUpdateStore } from '../../redux/actions';
import useFetchIfNeeded from '../../redux/useFetchIfNeeded';
import { useLocation } from 'react-router-dom';

const ChildProduct = ({
  rowData,
  handleChangeForm,
  handleAddRow,
  formData,
  handleChange,
  selectedOptions,
  handleDeleteRow,
  handleAddProductToQuoteItems,
  productsByAccountId,
  errormsg,
}) => {
  const gridRef = useRef();
  // const [formData, setFormData] = useState({ type: "view" });
  const [selectedOption, setSelectedOption] = useState({});
  const [isOpen, setIsOpen] = useState(false);
  const productOptions = useSelector(getProductDropdown);
  const [selectedRowsPopup, setSelectedRowsPopup] = useState([]);
  const [loading, setLoading] = useState(false);
  const [priceSheetByProductId, setPriceSheetByProductId] = useState([]);
  const productList = useSelector(getProductList);
  const location = useLocation();
  useFetchIfNeeded(getProductList, fetchDataAndUpdateStore, {
    key: 'productList',
    inputData: productInputData,
  });

  const currency = process.env.REACT_APP_CURRENCY;
  console.log('🚀 ~ ChildProduct ~ currency:', currency);

  // const handleChangeForm = (e) => {
  //   const { name, value } = e.target;
  //   let convertedValue = value;

  //   // For phone-related fields: Allow only numbers, +, -, parentheses, and spaces
  //   if (["amount"].includes(name)) {
  //     convertedValue = value.replace(/[^0-9+\-() ]/g, "");
  //   }
  //   // Clear the error for this field
  //   // setErrorMsg((prev) => ({
  //   //   ...prev,
  //   //   [name]: undefined,
  //   // }));

  //   // Update form data
  //   setFormData((prev) => ({
  //     ...prev,
  //     [name]: convertedValue,
  //   }));

  //   // setFormEdited(true);
  // };

  const fetchPriceSheetListByProductId = async (productId) => {
    try {
      const response = await apiServices.getPriceSheetsByProductId(productId); // Adjust this API name if needed
      if (response.status === 200) {
        setPriceSheetByProductId(response?.data?.productPriceSheetAssociations);
      } else {
        console.error('Failed to fetch price sheets:', response);
      }
    } catch (error) {
      console.error('Error while fetching price sheets by account:', error);
    }
  };

  const onSelectionChangedPopup = (event) => {
    setSelectedRowsPopup(event.api.getSelectedRows()); // Get all selected rows
  };

  const handleOpen = (productId) => {
    setIsOpen(true);
    fetchPriceSheetListByProductId(productId);
  };
  const handleClose = () => {
    setIsOpen(false);
  };
  const allColumnDefs = [
    {
      headerName: 'Actions',
      field: 'actions',
      width: 100,

      cellRenderer: (params) => {
        return (
          <div className="action-menu">
            <img
              onClick={() => handleDeleteRow(params.data.id, params.node.rowIndex)}
              src="/assets/images/trash.png"
              className="action-img2"
              alt="Delete Account"
              title="Delete Account"
            ></img>
          </div>
        );
      },
      suppressMovable: true,
      sortable: false,
      filter: false,
      editable: false,
    },
    {
      headerName: 'S.No.',
      valueGetter: (params) => params.node.rowIndex + 1,
      sortable: false,
      filter: false,
      maxWidth: 70,
      resizable: false,
      editable: false,
    },
    {
      headerName: 'Product Name',
      field: 'productId',
      editable: (params) => params?.data?.type !== 'view',
      cellEditor: 'agSelectCellEditor',
      cellEditorParams: {
        values: [
          'Select Product',
          ...(Array.isArray(productList) ? productList.map((p) => p.name) : []),
        ],
      },
      valueFormatter: (params) => {
        const product = Array.isArray(productList)
          ? productList.find((p) => p.id === params.value || p.name === params.value)
          : null;
        return product ? product.name : 'Select Product';
      },
      valueParser: (params) => {
        return params.newValue;
      },
      cellClassRules: {
        'cell-error': (params) => !params.value || params.value === 'Select Product',
      },
    },

    {
      headerName: 'Description',
      field: 'description',
      sortable: true,
      filter: false,
      editable: (params) => params?.data?.type !== 'view',
      cellEditor: 'agTextCellEditor',
    },
    {
      headerName: 'Quantity',
      field: 'quantity',
      sortable: true,
      filter: false,
      editable: (params) => params?.data?.type !== 'view',
      cellEditor: 'agNumberCellEditor',
    },
    {
      headerName: 'List Price',
      field: 'listPrice',
      sortable: true,
      filter: false,
      editable: (params) => params?.data?.type !== 'view',
      cellEditor: 'agNumberCellEditor',
    },
    {
      headerName: ' ',
      field: 'icon',
      sortable: false,
      filter: false,
      maxWidth: 50,
      editable: false,
      cellRenderer: (props) => {
        const selectedProductId = props.data.productId; // 👈 Access the selected productId here

        return (
          <div
            style={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              width: '100%',
            }}
            onClick={(e) => e.stopPropagation()} // Prevent cell from going to edit mode
          >
            <i
              className="bi bi-tag-fill"
              style={{ color: '#4C70BE', cursor: 'pointer' }}
              title="Click to trigger action"
              onClick={(e) => {
                e.stopPropagation();
                e.preventDefault();
                handleOpen(selectedProductId); // 👈 Pass it to your function
              }}
            ></i>
          </div>
        );
      },
    },

    {
      headerName: `Amount ${currency}`,
      field: 'amount',
      sortable: true,
      filter: false,
      editable: false,
      cellEditor: 'agNumberCellEditor',
    },

    {
      headerName: 'Discount Percent(%)',
      field: 'discountPercent',
      editable: (params) => !params.data.discountAmount, // disable if amount is set
      cellEditor: 'agNumberCellEditor',
      valueFormatter: (params) => (params.value !== undefined ? `${params.value.toFixed(2)}%` : ''),
    },
    {
      headerName: 'Discount Amount',
      field: 'discountAmount',
      editable: (params) => !params.data.discountPercent, // disable if percent is set
      cellEditor: 'agNumberCellEditor',
      valueFormatter: (params) => (params.value !== undefined ? `${params.value.toFixed(2)}` : ''),
    },
    {
      headerName: 'Tax Percent(%)',
      field: 'taxPercent',
      editable: (params) => !params.data.taxAmount,
      cellEditor: 'agNumberCellEditor',
      valueFormatter: (params) => (params.value !== undefined ? `${params.value.toFixed(2)}%` : ''),
    },
    {
      headerName: 'Tax Amount',
      field: 'taxAmount',
      editable: (params) => !params.data.taxPercent,
      cellEditor: 'agNumberCellEditor',
      valueFormatter: (params) => (params.value !== undefined ? `${params.value.toFixed(2)}` : ''),
    },

    {
      headerName: `Total ${currency}`,
      field: 'lineTotal',
      sortable: true,
      filter: false,
      editable: false,
      cellEditor: 'agTextCellEditor',
    },
  ];

  // 👉 Apply view mode rules
  const isViewMode = location.pathname.includes('View');

  const columnDefs = allColumnDefs
    // hide Actions + Icon in view mode
    .filter((col) => !(isViewMode && (col.field === 'actions' || col.field === 'icon')))
    // lock everything as non-editable in view mode
    .map((col) => ({
      ...col,
      editable:
        isViewMode
          ? false
          : col.editable, // keep original editable in edit mode
    }));

  //    const addRow = () => {
  //   const newRow = {
  //     product: "",
  //     description: "",
  //     quantity: 0,
  //     listPrice: 0,
  //     amount: 0,
  //     discount: 0,
  //     tax: 0,
  //     total: 0,
  //   };
  //   setRowData((prevData) => [...prevData, newRow]);
  // };

  //  const updateRow = (index, name, value) => {
  //     const updatedRows = [...rows];
  //     updatedRows[index][name] = value;

  //     // Auto-calculate
  //     const qty = Number(updatedRows[index].quantity) || 0;
  //     const price = Number(updatedRows[index].listPrice) || 0;
  //     const discount = Number(updatedRows[index].discountPercent) || 0;
  //     const tax = Number(updatedRows[index].taxPercent) || 0;

  //     const amount = qty * price;
  //     const discountAmt = (amount * discount) / 100;
  //     const taxAmt = (amount * tax) / 100;
  //     const total = amount - discountAmt + taxAmt;

  //     updatedRows[index].amount = amount;
  //     updatedRows[index].total = total;

  //     setRows(updatedRows);
  //   };
  const defaultColDef = useMemo(() => ({
    sortable: true,
    editable: false,
    flex: 1,
    minWidth: 20,
    filter: true,
    resizable: true,
    // allow every column to be aggregated
    enableValue: true,
    // allow every column to be grouped
    enableRowGroup: false,
    // allow every column to be pivoted
    enablePivot: true,
    //cellRenderer: supressEdit,
  }));

  const priceSheetColumnDefs = [
    {
      headerName: 'Name',
      field: 'priceSheetName',
      width: 150,
      filter: 'agSetColumnFilter',
      headerCheckboxSelection: true,
      checkboxSelection: true,
    },
    {
      headerName: 'Currency',
      field: 'currencyPrice',
      width: 150,
      filter: 'agSetColumnFilter',
    },
    {
      headerName: 'List Price',
      field: 'listPrice',
      width: 150,
      filter: 'agSetColumnFilter',
    },
  ];

  const handleSubmit = () => {
    // const selectedListPrice = selectedRowsPopup.map((row) => row.listPrice);

    handleAddProductToQuoteItems(selectedRowsPopup);
    setSelectedRowsPopup([]);
    handleClose();
  };
  console.log(errormsg);
  return (
    <div className="row Cnt_view">
      <div className="col-12 col-sm-12 col-md-12">
        <div className="infoBox">
          <div className="addlead-header pd_card">
            <label htmlFor="" className="flex-div align-items-center">
              <img className="me-2" src="../assets/quoteAi/images/quotesItemInfo.svg" alt="" />
              Items<span className="required-star">*</span>
            </label>
            
            <span className="error-message">{errormsg?.['quoteDetails[0].productId']}</span>
          </div>
          <div className="quoteContent">
            <>
              <div className="row">
                <div className="col-12 col-sm-12 col-md-9">
                  <div className="cutome_ag_theme" id="viewPageGrid">
                    <div
                      className="ag-theme-balham tbl_height"
                      style={{
                        // minWidth: "1333px",
                        height: '322px',
                      }}
                    >
                      <AgGridReact
                        // domLayout="fixedHeight"
                        ref={gridRef}
                        rowData={rowData?.quoteDetails}
                        columnDefs={columnDefs}
                        // defaultColDef={defaultColDef}
                        defaultColDef={{ resizable: true, editable: true, minWidth: 100, }}
                        rowSelection="multiple"
                        alwaysShowVerticalScroll={true}
                        stopEditingWhenCellsLoseFocus={true}
                        singleClickEdit={true}
                        onCellValueChanged={(params) => {
                          handleChangeForm(params.data, params.node.rowIndex, 'quoteDetails');

                          if (params.colDef.field === 'productId') {
                            const selectedProduct = productOptions.find(
                              (p) => p.name === params.newValue
                            );

                            if (selectedProduct) {
                              handleChange(
                                {
                                  value: selectedProduct.id,
                                  label: selectedProduct.name,
                                },
                                'productId',
                                params.node.rowIndex // ✅ pass row index here
                              );
                            }
                          } else {
                            handleChange(params.colDef.field, params.newValue);
                          }
                        }}
                      />
                    </div>
                  </div>
                  {/* <table className="table table-bordered">
                    <thead>
                      <tr>
                        <th>S.NO</th>
                        <th>Product Name</th>
                        <th>Quantity</th>
                        <th>List Price($)</th>
                        <th>Amount($)</th>
                        <th>Discount($)</th>
                        <th>Tax($)</th>
                        <th>Total($)</th>
                      </tr>
                    </thead>
                    <tbody>
                      {rowData?.map((row, index) => (
                        <tr key={index}>
                          <td>
                            {index + 1}
                            {rowData?.length > 1 && (
                              <i
                                className="bi bi-dash-circle text-danger"
                                style={{
                                  cursor: "pointer",
                                  fontSize: "1.2rem",
                                }}
                                onClick={() => handleDeleteRow(index)}
                                title="Delete Row"
                              />
                            )}
                          </td>

                          <td>
                            <div
                              style={{
                                display: "flex",
                                flexDirection: "column",
                                gap: "8px",
                              }}
                            >
                              <SelectBox
                                name={"productId"}
                                placeholder={
                                  formData?.type === "view"
                                    ? formData?.product || "--"
                                    : formData?.product ||
                                      "Select Parent Account"
                                }
                                selectedOptions={selectedOptions?.productId}
                                handleSelect={handleChange}
                                disabled={formData?.type === "view"}
                                options={productOptions}
                                optionKeys={["id", "name"]}
                              />
                              <TextArea
                                name="description"
                                placeholder="Description"
                                value={row.description}
                                handleChange={(e) => handleChangeForm(e, index)}
                              />
                            </div>
                          </td>

                          <td>
                            <TextBox
                              name="quantity"
                              value={row.quantity}
                              handleChange={(e) => handleChangeForm(e, index)}
                              fieldType="number"
                            />
                          </td>

                          <td>
                            <TextBox
                              name="listPrice"
                              value={row.listPrice}
                              handleChange={(e) => handleChangeForm(e, index)}
                              fieldType="number"
                            />
                          </td>

                          <td>
                            <TextBox
                              name="amount"
                              value={row.amount?.toFixed?.(2) ?? 0}
                              // disabled={true}
                              fieldType="number"
                            />
                          </td>

                          <td>
                            <TextBox
                              name="discountPercent"
                              value={row.discountPercent}
                              handleChange={(e) => handleChangeForm(e, index)}
                              fieldType="number"
                            />
                          </td>

                          <td>
                            <TextBox
                              name="taxPercent"
                              value={row.taxPercent}
                              handleChange={(e) => handleChangeForm(e, index)}
                              fieldType="number"
                            />
                          </td>

                          <td>
                            <TextBox
                              name="lineTotal"
                              value={row.lineTotal?.toFixed?.(2) ?? 0}
                              // disabled={true}
                              fieldType="number"
                            />
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table> */}
                  {rowData?.type != 'view' && (
                    <button
                      type="button"
                      className="btn btn-primary btn-square"
                      onClick={handleAddRow}
                      title="Add Row"
                    >
                      <i className="bi bi-plus-lg"></i>
                    </button>


                  )}
                </div>
                <div className="col-12 col-sm-12 col-md-3">
                  <div className="orderSummary">
                    <div className="summaryDes textRight">
                      <div className="summaryHeader">
                        <h2>Quote's Summary</h2>
                      </div>
                      <div className="summaryRow">
                        <TextBox
                          // isRequired={true}
                          label={'Sub Total'}
                          name={'subTotal'}
                          placeholder={formData?.type === 'view' ? `${currency} 0.00` : '0'}
                          value={`${currency} ${formData?.subTotal?.toFixed(2) || '0.00'}`}
                          handleChange={handleChangeForm}
                          maxLength={50}
                          errormsg={errormsg?.subTotal}
                          disabled={true}
                        />
                      </div>

                      <div className="summaryRow">
                        <TextBox
                          label={'Discount'}
                          name={'discountTotal'}
                          placeholder={formData?.type === 'view' ? `${currency} 0.00` : '0'}
                          value={`${currency} ${formData?.discountTotal?.toFixed(2) || '0.00'}`}
                          handleChange={handleChangeForm}
                          maxLength={50}
                          errormsg={errormsg?.discount}
                          disabled={true}
                        />
                      </div>

                      <div className="summaryRow">
                        <TextBox
                          label={'Tax'}
                          name={'taxTotal'}
                          placeholder={formData?.type === 'view' ? `${currency} 0.00` : '0'}
                          value={`${currency} ${formData?.taxTotal?.toFixed(2) || '0.00'}`}
                          handleChange={handleChangeForm}
                          maxLength={50}
                          errormsg={errormsg?.taxTotal}
                          disabled={true}
                        />
                      </div>

                      <div className="summaryRow">
                        <TextBox
                          label={'Adjustment'}
                          name={'adjustment'}
                          placeholder={formData?.type === 'view' ? `${currency} 0.00` : '0'}
                          value={
                            formData?.type === 'view'
                              ? `${currency} ${Number(formData?.adjustment || 0).toFixed(2)}`
                              : formData?.adjustment || ''
                          }
                          handleChange={handleChangeForm}
                          maxLength={50}
                          errormsg={errormsg?.noOfEmployees}
                          disabled={formData?.type === 'view'}
                        />
                      </div>

                      <div className="summaryRow totalRow">
                        <TextBox
                          label={'Grand Total'}
                          name={'grandTotal'}
                          placeholder={formData?.type === 'view' ? `${currency} 0.00` : '0'}
                          value={`${currency} ${formData?.grandTotal?.toFixed(2) || '0.00'}`}
                          handleChange={handleChangeForm}
                          maxLength={50}
                          errormsg={errormsg?.grandTotal}
                          disabled={true}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </>
          </div>
        </div>
        {isOpen && (
          <div id="genricPopup">
            <div className="popup-backdrop">
              <div className="popup fullWidthPopup">
                {/* Popup Header */}
                <div className="popup-header">
                  <h4 className="popup-title">Choose PriceSheet</h4>
                  <button className="custom-btn-close" onClick={handleClose}></button>
                </div>
                {/* Popup Body */}
                <div className="popup-body">
                  <div className="popupbody_header">
                    <div className="hd_leftview">
                      <div className="heading_item" id="contct_search">
                        {/* <div className="search-container">
                                      <input
                                        type="text"
                                        id="filter-text-box"
                                        className={`form-control${searchText ? " focused" : ""}`}
                                        placeholder="Search..."
                                        value={searchText}
                                        onChange={(e) => setSearchText(e.target.value)}
                                        onKeyDown={handleKeyDown}
                                      />

                                      {searchText && (
                                        <span className="clear-btn" onClick={clearSearch}>
                                          &times;
                                        </span>
                                      )}
                                      <button className="contactsearch" type="button" onClick={() => onSearch(searchText)}
                                        onFocus={() => setIsFocused(true)} onBlur={() => setIsFocused(false)}>
                                        <svg
                                          xmlns="http://www.w3.org/2000/svg"
                                          width="20"
                                          height="20"
                                          viewBox="0 0 24 24"
                                          fill="none"
                                          stroke="currentColor"
                                          strokeWidth="2"
                                          strokeLinecap="round"
                                          strokeLinejoin="round"
                                        >
                                          <circle cx="11" cy="11" r="8"></circle>
                                          <line x1="21" y1="21" x2="16.65" y2="16.65"></line>
                                        </svg>
                                      </button>
                                    </div> */}
                      </div>
                      {/* <div className="flx_heding view_fnt" id="action_dropdown">

                                  <>
                                    <label
                                      htmlFor="memberStatusId"
                                      style={{ width: "100px" }}
                                    >
                                      Member Status:
                                    </label>
                                    <Select
                                      id="memberStatus"
                                      value={selectedOptions.memberStatus}
                                      placeholder={formData.memberStatusId}
                                      onChange={(selectedOption) =>
                                        handleChange(selectedOption, "memberStatusId")
                                      }
                                      options={memberStatus?.map((data) => ({
                                        value: data.id,
                                        label: data.displayName,
                                      }))}
                                      styles={{
                                        container: (base) => ({
                                          ...base,
                                          width: "200px",
                                          minHeight: "30px"
                                        }),
                                        menu: (base) => ({
                                          ...base,
                                          zIndex: "9999",
                                          height: "200px",
                                          overflow: "auto",
                                          color: "#000",
                                        }),
                                        control: (base) => ({
                                          ...base,
                                          borderRadius: "6px",
                                        }),
                                      }}
                                    />
                                  </>
                                </div> */}
                    </div>
                    <div className="hd_rightview" id="update_campaign">
                      <div className="flx_heding view_fnt">
                        <label>
                          Total Records: <span>{priceSheetByProductId?.length}</span>
                        </label>
                      </div>

                      <span className="separator"></span>
                      <div className="flx_heding">
                        <button
                          className="add-btn"
                          type="button"
                          onClick={() => handleSubmit(formData)}
                          disabled={!selectedRowsPopup.length > 0 || loading}
                        >
                          {selectedRowsPopup.length > 0 && loading && (
                            <>
                              {' '}
                              <div
                                className="spinner-border spinner-border-sm me-2"
                                role="status"
                              ></div>
                            </>
                          )}
                          {selectedRowsPopup.length > 0 && loading
                            ? 'Loading...'
                            : 'Add to Quote Items'}
                        </button>
                      </div>

                      {/* Popup 2 Overlay */}
                    </div>
                  </div>
                  <div className="cutome_ag_theme" style={{ marginTop: '1rem' }}>
                    <div
                      className="ag-theme-balham tbl_height"
                      style={{
                        height: 'calc(100vh - 320px)',
                        width: '100%',
                      }}
                    >
                      <AgGridReact
                        rowData={priceSheetByProductId}
                        columnDefs={priceSheetColumnDefs}
                        suppressRowClickSelection={true}
                        defaultColDef={{
                          flex: 1,
                          minWidth: 100,
                          resizable: true,
                        }}
                        // sideBar={sideBar}
                        rowSelection="multiple"
                        onSelectionChanged={onSelectionChangedPopup}
                        ref={gridRef}
                      // statusBar={statusBar}
                      // onGridReady={onGridReady}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default ChildProduct;
